export default "__VITE_ASSET__899504d4__"